// Main styles
import "../index.css";

// Import animations
import "../css/animations.css";
import { initScrollAnimations } from "./modules/scroll-animations";

// Import libraries
// import Alpine from "alpinejs";
// import { gsap } from "gsap";

// Import components
import initHeader from "./components/header";
import { initNewsletterForm } from "./modules/newsletter-form";
import { initPostCardExcerpts } from "./components/post-card-excerpt";
import { initNotificationOverlay } from "./modules/notification-overlay";

// Make Alpine available globally
// window.Alpine = Alpine;
// Alpine.start();

// Initialize components
document.addEventListener("DOMContentLoaded", () => {
  // Initialize header components
  initHeader();

  // Initialize newsletter form
  initNewsletterForm();

  // Initialize post card excerpts
  initPostCardExcerpts();

  // Initialize scroll animations
  initScrollAnimations();

  // Initialize notification overlay
  initNotificationOverlay();

  console.log("Main script loaded");
});
